

















import {Vue, Component, Prop, Emit, Model, Watch, Provide} from 'vue-property-decorator';

@Component({
  name: 'MyForm'
})
export default class MyForm extends Vue {
  @Prop() validItemArr: string[]; // 需要校验的字段

  @Model('change')
  formResult: object

  @Watch('formResult', {
    deep: true
  })
  onChangeFormResult(newValue) {}

  // 校验整个form的正确性
  validForm() {
    for(const item of this.validItemArr) {
      if(this.formResult[item + 'Result'] !== true) {
        this.formResult.isValid = false;
        return;
      }
      this.formResult.isValid = true;
    }
  };
}
